import { render } from "./PlayoutHeaderV2.vue?vue&type=template&id=df7e2e30"
import script from "./PlayoutHeaderV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutHeaderV2.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayoutV2/PlayoutHeaderV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "df7e2e30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df7e2e30', __exports__)) {
    api.reload('df7e2e30', __exports__)
  }
  
  module.hot.accept("./PlayoutHeaderV2.vue?vue&type=template&id=df7e2e30", () => {
    api.rerender('df7e2e30', render)
  })

}


export default __exports__